import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import BorderedLayout from "../../../layouts/BorderedLayout";
import { GetSettlementRequestDetailByKeyResponse } from "../../../models/settlement.model";

type Props = Omit<GetSettlementRequestDetailByKeyResponse, "sales">;
const SupplierSettelmentRequestDetailHeader = ({
  creatorName,
  createDatePersian,
  settlementTypeTitle,
  settlementAmount,
  factorAmount,
  confirmerName,
  confirmDatePersian,
  sayadNumber,
  chequeSeri,
  chequeSerial,
  chequeDueDatePersian,
  creatorDescription,
  confirmerDescription,
  settlementType,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div>
      <BorderedLayout
        title={
          <Typography
            sx={{
              color: "#1D4A87",
              fontSize: "1.1rem",
              fontWeight: "bold",
            }}
          >
            مشخصات درخواست تسویه
          </Typography>
        }
        backgroundColor="#F9FAFC"
      >
        <Grid container sx={{ padding: "20px" }} gap={"20px"}>
          {/* top section */}
          <Grid item xs={12}>
            <Grid container flexDirection={isMobile ? "column" : "row"}>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    color: "#9AAFC4",
                    fontSize: "1rem",
                    display: "ruby-text",
                  }}
                >
                  ثبت کننده:{" "}
                  <span style={{ color: "#34495E" }}>{creatorName}</span>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    color: "#9AAFC4",
                    fontSize: "1rem",
                    display: "ruby-text",
                  }}
                >
                  تاریخ ثبت:{" "}
                  <span style={{ color: "#34495E" }}>{createDatePersian}</span>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    color: "#9AAFC4",
                    fontSize: "1rem",
                    display: "ruby-text",
                  }}
                >
                  نوع تسویه:{" "}
                  <span style={{ color: "#34495E" }}>
                    {settlementTypeTitle}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    color: "#9AAFC4",
                    fontSize: "1rem",
                    display: "ruby-text",
                  }}
                >
                  مبلغ تسویه:{" "}
                  <span style={{ color: "#FB8C00", fontWeight: "bold" }}>
                    {settlementAmount.toLocaleString("fa")} ریال
                  </span>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* middle section  */}
          <Grid item xs={12}>
            <Grid container flexDirection={isMobile ? "column" : "row"}>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    color: "#9AAFC4",
                    fontSize: "1rem",
                    display: "ruby-text",
                  }}
                >
                  مجموع مبلغ فاکتور:{" "}
                  <span style={{ color: "#34495E" }}>
                    {factorAmount.toLocaleString("fa")} ریال
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    color: "#9AAFC4",
                    fontSize: "1rem",
                    display: "ruby-text",
                  }}
                >
                  تایید کننده:{" "}
                  <span style={{ color: "#34495E" }}>
                    {confirmerName.trim().length === 0 ? "--" : confirmerName}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    color: "#9AAFC4",
                    fontSize: "1rem",
                    display: "ruby-text",
                  }}
                >
                  تاریخ تایید:{" "}
                  <span style={{ color: "#34495E" }}>
                    {" "}
                    {confirmDatePersian.trim().length === 0
                      ? "--"
                      : confirmDatePersian}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                {settlementType === "Cheque" ? (
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    شماره صیادی چک:{" "}
                    <span style={{ color: "#34495E" }}>{sayadNumber}</span>
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    شماره تراکنش:{" "}
                    <span style={{ color: "#34495E" }}>{sayadNumber}</span>
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
          {/* bottom section */}
          <Grid item xs={12}>
            {settlementType === "Cheque" ? (
              <Grid container flexDirection={isMobile ? "column" : "row"}>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    سری چک:{" "}
                    <span style={{ color: "#34495E" }}>{chequeSeri}</span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    سریال چک:{" "}
                    <span style={{ color: "#34495E" }}>{chequeSerial}</span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    تاریخ سررسید چک:{" "}
                    <span style={{ color: "#34495E" }}>
                      {chequeDueDatePersian}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}></Grid>
              </Grid>
            ) : (
              <Grid container flexDirection={isMobile ? "column" : "row"}>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    تاریخ واریز:{" "}
                    <span style={{ color: "#34495E" }}>{chequeSeri}</span>
                  </Typography>
                </Grid>
                <Grid item xs={8}></Grid>
              </Grid>
            )}
          </Grid>
          {/* description section */}
          <Grid
            item
            xs={12}
            sx={{
              borderTop: "1px solid #C1C7CB",
              paddingTop: "20px",
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
            flexDirection={isMobile ? "column" : "row"}
          >
            <Typography
              sx={{ color: "#9AAFC4", fontSize: "1rem", display: "ruby-text" }}
            >
              توضیحات ثبت کننده:{" "}
              <span style={{ color: "#34495E" }}>{creatorDescription}</span>
            </Typography>
            <Typography
              sx={{ color: "#9AAFC4", fontSize: "1rem", display: "ruby-text" }}
            >
              توضیحات تایید کننده:{" "}
              <span style={{ color: "#34495E" }}>
                {" "}
                {confirmerDescription.trim().length === 0
                  ? "--"
                  : confirmerDescription}
              </span>
            </Typography>
          </Grid>
        </Grid>
      </BorderedLayout>
    </div>
  );
};

export default SupplierSettelmentRequestDetailHeader;
